<template>
  <el-dialog
    :append-to-body="true"
    :title="$t('product.快速关联')"
    width="60%"
    :visible.sync="dialog.visible"
  >
    <div class="flex-box">
      <div>
        <div class="mb-2">SKU：{{ dataList.sku }}</div>
      </div>
      <div>
        <el-button size="small" class="mb-2" type="primary" @click="addSupplier"
          >{{$t('product.添加材料')}}</el-button
        >
      </div>
    </div>
    <el-dialog :append-to-body="true" :title="$t('product.添加原料SkU')" :visible.sync="addSupplierdialog">
      <el-form :model="addSupplierList" label-width="120px">
        <el-form-item :label="$t('product.材料名称')">
            <el-autocomplete
              v-model="addSupplierList.name"
              :fetch-suggestions="querySearchAsync"
              :placeholder="$t('product.请输入材料名称')"
            ></el-autocomplete>
        </el-form-item>
        <el-form-item :label="$t('product.数量')">
          <el-input oninput="value=value.replace(/[^0-9]/g,'')" v-model="addSupplierList.num"></el-input>
        </el-form-item>
        <!-- <el-form-item :label="$t('product.价格')">
          <el-input oninput="value=value.replace(/[^0-9.]/g,'')" v-model="addSupplierList.price"></el-input>
        </el-form-item> -->
        <el-form-item>
            <el-button size="small" type="primary" @click="onSubmit">{{$t('product.添加')}}</el-button>
            <el-button size="small" @click="cancel">{{$t('product.取消')}}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-table
      :data="dataList.childStocks"
      style="width: 100%"
      size="small"
      :header-cell-style="{ background: '#FAFAFA' }"
    >
      <el-table-column prop="name" :label="$t('product.材料SKU')" align="center">
      </el-table-column>
      <el-table-column prop="num" :label="$t('product.数量')" align="center">
        <template slot-scope="scope">
          <span>{{Number(scope.row.num).toFixed(0)}}</span>
          </template>
      </el-table-column>
      <el-table-column :label="$t('product.操作')" align="center">
          <template slot-scope="scope">
						<el-link class="text-danger" type="primary" @click="delLogList(scope.row,scope.$index)">{{$t('product.删除')}}</el-link>
					</template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="save">{{$t('product.保存')}}</el-button>
        <el-button size="small" @click="close">{{$t('product.关闭')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Object,
      default: function () {
        return {
          visible: false,
          data: {},
        };
      },
    },
  },
  data() {
    return {
      addSupplierdialog: false,
      restaurants: [],
      addSupplierList: {
        name: "",
        id: "",
        num: "",
        price:"",
      },
      rawSkuId: '',
      dataList: this.dialog.data,
    };
  },
  watch: {
    dialog: {
      deep: true,
      handler: function () {
        this.dataList = this.dialog.data;
      },
    },
  },
  methods: {
    delLogList(item,index){
      $.api_call(
        "api.SupplierProductStock.deleteRawRelation",
        {
          skuId: this.dialog.data.id,
          rawSkuId: item.id,
        },
        (r) => {
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("transfer.操作成功"), "success");
            this.dataList.childStocks.splice(index,1)
          }
        }
      );
    },
    addSupplier() {
      this.addSupplierdialog = true;
    },
    querySearchAsync(queryString, cb) {
      if (!queryString) {
        return false;
      }
      $.api_call(
        "api.SupplierProductStock.findRawSkuByName",
        {
          name: queryString,
        },
        (r) => {
          if (r.ErrorCode == "9999") {
            if(r.Data.Results.length == 0){
              ShowTip(this.$t('product.搜索不到数据'), "danger");
            }
            this.restaurants = r.Data.Results;
            var results = queryString
              ? this.restaurants.filter(
                  (item) => item.name.indexOf(queryString) > -1
                )
              : this.restaurants;
            results = results.map((item) => ({ value: item.name }));
            cb(results);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      );
    },
    onSubmit(){
      this.restaurants.forEach((item) => {
        if (item.name == this.addSupplierList.name) {
          this.rawSkuId = item.id;
        }
      });
      $.api_call(
        "api.SupplierProductStock.addRawRelation",
        {
          skuId: this.dialog.data.id,
          rawSkuId: this.rawSkuId,
          num: this.addSupplierList.num,
        },
        (r) => {
          // this.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("transfer.操作成功"), "success");
            this.dataList.childStocks.push({rawSkuId: this.rawSkuId,name:this.addSupplierList.name,num:this.addSupplierList.num})
            this.addSupplierdialog = false
          }
        }
      );
    },
    cancel(){
      this.addSupplierdialog = false
      this.addSupplierList.name = ''
      this.addSupplierList.num= ''
    },
    save(){
      this.$emit('close')
    },
    close(){
      this.$emit('close')
    }

  },
};
</script>

<style scoped>
.flex-box {
  display: flex;
  justify-content: space-between;
}
</style>
